import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const SIGNUP_REQUEST = 'sherrinford/admin-created-user/add/SIGNUP_REQUEST'
export const SIGNUP_SUCCESS = 'sherrinford/admin-created-user/add/SIGNUP_SUCCESS'
export const SIGNUP_ERROR = 'sherrinford/admin-created-user/add/SIGNUP_ERROR'

export const USER_PROFILE_REQUEST = 'sherrinford/admin-created-user/add/USER_PROFILE_REQUEST'
export const USER_PROFILE_SUCCESS = 'sherrinford/admin-created-user/add/USER_PROFILE_SUCCESS'
export const USER_PROFILE_ERROR = 'sherrinford/admin-created-user/add/USER_PROFILE_ERROR'

export const IS_LOADING = 'sherrinford/admin-created-user/add/IS_LOADING'
export const DATA = 'sherrinford/admin-created-user/add/DATA'

export const ERROR = 'sherrinford/admin-created-user/add/ERROR'
export const ERROR_CLEAN = 'sherrinford/admin-created-user/ERROR_CLEAN'
export const INIT_STATE = 'sherrinford/admin-created-user/INIT_STATE'

export const VALIDATE_EMAIL_REQUEST = 'sherrinford/admin-created-user/add/VALIDATE_EMAIL_REQUEST'
export const VALIDATE_EMAIL_SUCCESS = 'sherrinford/admin-created-user/add/VALIDATE_EMAIL_SUCCESS'
export const VALIDATE_EMAIL_ERROR = 'sherrinford/admin-created-user/add/VALIDATE_EMAIL_ERROR'

const initialState = {
  data: {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    tempPassword: '',
    profileName: '',
    profileId: '',
    country: '',
    city: '',
    source: 'admin',
    defaultFeature: '',
  },
  isLoading: false,
  isError: false,
  errorMessage: '',
  isEmailExists: 0,
}

export default createReducer(initialState, {
  [SIGNUP_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [SIGNUP_SUCCESS]: (state, res) => ({
    ...state,
    registered: {
      ...state.registered,
      ...res,
    },
    isLoading: false,
  }),

  [SIGNUP_ERROR]: (state, res) => {
    const {
      invalidAttributes: errorMessage,
    } = res
    return {
      ...state,
      isLoading: false,
      isError: true,
      errorMessage,
    }
  },

  [VALIDATE_EMAIL_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [VALIDATE_EMAIL_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [VALIDATE_EMAIL_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, payload) => ({
    ...state,
    data: {
      ...state.data,
      ...payload,
    },
  }),

  [ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
  }),

  [ERROR_CLEAN]: state => ({
    ...state,
    isError: false,
    errorMessage: '',
  }),

  [INIT_STATE]: state => ({
    ...state,
    data: initialState.data,
  }),
})

export const setUser = (data, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      SIGNUP_REQUEST,
      SIGNUP_SUCCESS,
      SIGNUP_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/user',
      authorization: `${token}`,
      payloads: data,
    },
    nextAction: res => cb(res),
  }
}

export const setProfile = (data, cb = () => {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      USER_PROFILE_REQUEST,
      USER_PROFILE_SUCCESS,
      USER_PROFILE_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/profile',
      payloads: data,
      authorization: `${token}`,
    },
    nextAction: res => cb(res),
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setError = data => ({
  type: [ERROR],
  payload: data,
})

export const setErrorClean = data => ({
  type: [ERROR_CLEAN],
  payload: data,
})

export const initState = () => ({
  type: [INIT_STATE],
})

export function getValidateEmail(email, cb = () => {}) {
  return {
    type: [
      VALIDATE_EMAIL_REQUEST,
      VALIDATE_EMAIL_SUCCESS,
      VALIDATE_EMAIL_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/user/validate',
      payloads: {
        email,
      },
    },
    nextAction: res => cb(res),
  }
}
